package ir.yusefpasha.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import ir.yusefpasha.components.ExperienceCard
import ir.yusefpasha.components.SectionTitle
import ir.yusefpasha.models.Experience
import ir.yusefpasha.models.Section
import ir.yusefpasha.util.Constants
import ir.yusefpasha.util.ObserveViewportEntered
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun ExperienceSection() {
    val breakpoint = rememberBreakpoint()
    Box(
        modifier = Modifier
            .id(Section.Experience.id)
            .maxWidth(Constants.SECTION_WIDTH.px)
            .padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        ExperienceContent(breakpoint)
    }
}

@Composable
private fun ExperienceContent(breakpoint: Breakpoint) {

    var animatedMargin by remember { mutableStateOf(200.px) }

    ObserveViewportEntered(
        sectionId = Section.Experience.id,
        distanceFromTop = 700.0
    ) {
        animatedMargin = 50.px
    }

    Column(
        modifier = Modifier
            .fillMaxWidth(
                if (breakpoint >= Breakpoint.MD) 100.percent
                else 90.percent
            ),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SectionTitle(
            modifier = Modifier.margin(bottom = 25.px).fillMaxWidth(
                if (breakpoint >= Breakpoint.MD) 60.percent
                else 90.percent
            ),
            section = Section.Experience,
            alignment = Alignment.Start
        )

        Experience.values().forEach { experience ->
            ExperienceCard(
                active = experience == Experience.First,
                breakpoint = breakpoint,
                experience = experience,
                animatedMargin = animatedMargin
            )
        }
    }
}